import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {useStore} from "../../../app/stores/rootStore";

export default observer(function ResponsiveHeaderPage() {      
  const { commonStore,userStore:{user},userStore, cartStore, wishlistStore } = useStore();
  const navigate = useNavigate();  
  useEffect(() => {
    if (commonStore.token) {
        // userStore now handles fetching automatically via the constructor listener
        // Just wait for it to finish loading
        if (!userStore.loading) {
            commonStore.setAppLoaded(true);
        }
    } else {
        commonStore.setAppLoaded(true);
    }
}, [commonStore, userStore.loading]);
useEffect(() => {
        // Syncs local/remote cart based on auth status        
        cartStore.syncCart(user?.uid);
    }, [user, cartStore]);

  const handleLogout = () => {
    userStore.logout();
    navigate('/');
  };

  return ( 
    <section data-bs-version="5.1" className="menu menu1 shopm5 cid-uATHtov5yG" id="amenu1-0">   
      <nav className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg">
        <div className="container-fluid">
          {/* Logo Section */}
          <div className="navbar-brand">
            <span className="navbar-logo">
              <a onClick={() => navigate("/")} style={{cursor: 'pointer'}}>
                <img src="/assets/images/voguishtrendycouture_finallogo.jpg" alt="Voguish Trendy" />
              </a>
            </span>
            <span className="navbar-caption-wrap">
              <a className="navbar-caption text-danger display-5" onClick={() => navigate("/")} style={{cursor: 'pointer', paddingLeft: '4px'}}>
                Voguish Trendy Couture
              </a>
            </span>
          </div>

          {/* User Actions (Cart & Wishlist Icons) */}
          <div className="d-flex align-items-center">
            {/* Wishlist Icon */}
            {userStore.isLoggedIn ?
            <a className="nav-link link text-danger position-relative" style={{cursor:'pointer'}} onClick={() => {navigate("/wishlist")}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-heart" viewBox="0 0 16 16">
                <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"/>
              </svg>
              {wishlistStore.itemCount > 0 && <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{fontSize:'0.6rem'}}>{wishlistStore.itemCount}</span>}
            </a> : null }

            {/* Cart Icon */}
            <a className="nav-link link text-danger position-relative" style={{cursor:'pointer'}} onClick={() => navigate("/cart")}>            
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-cart" viewBox="0 0 16 16">
                <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
              </svg>
              {cartStore.itemCount > 0 && <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{fontSize:'0.6rem'}}>{cartStore.itemCount}</span>}                                     
            </a>
          </div>

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <div className="hamburger">
              <span></span><span></span><span></span><span></span>
            </div>
          </button>                                                       

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav nav-dropdown" data-app-modern-menu="true">
              <li className="nav-item"><a className="nav-link link text-danger display-7" onClick={() => navigate("/")}>Home</a></li>
              <li className="nav-item"><a className="nav-link link text-danger display-7" onClick={() => navigate("/aboutus")}>About us</a></li>
              <li className="nav-item"><a className="nav-link link text-danger display-7" onClick={() => navigate("/catalog")}>Catalog</a></li>
              <li className="nav-item"><a className="nav-link link text-danger display-7" onClick={() => navigate("/contactus")}>Contacts</a></li>
              
              {/* Conditional Authentication Menu */}
              {userStore.isLoggedIn ? (
                <li className="nav-item dropdown">
                  <a className="nav-link link text-danger dropdown-toggle display-7" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="bi bi-person-circle me-1"></i> My Account
                  </a>
                  <div className="dropdown-menu dropdown-menu-end shadow border-0 rounded-3">
                    <a className="dropdown-item text-danger py-2" onClick={() => navigate("/dashboard")}>
                      <i className="bi bi-speedometer2 me-2"></i> Dashboard
                    </a>
                    <a className="dropdown-item text-danger py-2" onClick={() => navigate("/wishlist")}>
                      <i className="bi bi-heart me-2"></i> My Wishlist
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item text-muted py-2" onClick={handleLogout} style={{cursor:'pointer'}}>
                      <i className="bi bi-box-arrow-right me-2"></i> Logout
                    </a>
                  </div>
                </li>
              ) : (
                <li className="nav-item">
                  <a className="nav-link link text-danger display-7" onClick={() => navigate("/login")}>
                    Login
                  </a>
                </li>
              )}
            </ul>                     
          </div>                                  
        </div>
      </nav>
    </section>
  )
})